// extracted by mini-css-extract-plugin
module.exports = {"button":"sort-button_button__wnRgN","icon":"sort-button_icon__TSwjP","icon_mirror":"sort-button_icon_mirror__lPSw0"};